import { Pipe, PipeTransform } from '@angular/core';

import { TextTools } from 'appshared/text-tools';

@Pipe({
	name: 'acronym'
})
export class AcronymPipe implements PipeTransform {
	constructor() { }

	transform(words: string, splitOnOthers: boolean = false): string {
		if (!words) return '';
		return TextTools.acronym(words.trim(), splitOnOthers);
	}
}
